import { xlCol, xlColq } from '../../../common/constants'

export const reportName = 'Short Receive Report'

export const reportViewOptions = [
  { view: 'Detailed', id: 0 },
]

export const criteriaHeaders = [
  { field: 'selectedCompany', header: 'Selected Company', textAlign: 'left' },
  { field: 'fromDate', header: 'From Short receive Date', textAlign: 'left' },
  { field: 'toDate', header: 'To Short receive date', textAlign: 'left' },
  { field: 'dispatchByBranch', header: 'Dispatch By Branch', textAlign: 'left' },
  { field: 'shortReceiveByUser', header: 'Short receive By user', textAlign: 'left' },
  { field: 'shortReceiveByBranch', header: 'Short receive By Branch', textAlign: 'left' },
  { field: 'vehicleNumber', header: 'Vehicle Number', textAlign: 'left' },
  { field: 'paymentType', header: 'Payment Type', textAlign: 'left' },
  { field: 'reportView', header: 'Report View', textAlign: 'left' },
]

export const shortReceiveReportHeaders = [
  { header: 'SR', exportHead: 'SR', field: 'srNo', xlCol, weight: 40, align: 'right' },
  { header: 'LR No.', exportHead: 'LR No.', field: 'LRNO', xlCol, weight: 90 },
  { header: 'Pay Type', exportHead: 'Pay Type', field: 'PaymentType', xlCol, weight: 70 },
  { header: 'Dispatch Date', exportHead: 'Dispatch Date', field: 'BookingDateTime', xlCol, weight: 90 },
  { header: 'Short Receive Date', exportHead: 'Short Receive Date', field: 'ShortReceiveDate', xlCol, weight: 90 },
  { header: 'Sender', exportHead: 'Sender', field: 'Sender', xlCol, weight: 80 },
  { header: 'Receiver', exportHead: 'Receiver', field: 'RecName', xlCol, weight: 80 },
  { header: 'From City', exportHead: 'From City', field: 'FromCity', xlCol, weight: 70 },
  { header: 'To City', exportHead: 'To City', field: 'ToCity', xlCol, weight: 70 },
  { header: 'Vehicle', exportHead: 'Vehicle', field: 'VehicleNo', xlCol, weight: 100 },
  { header: 'Short Unit', exportHead: 'Short Unit', field: 'ShortQty', xlCol: xlColq, weight: 60, align: 'right' },
  { header: 'Other Charge', exportHead: 'Other Charge', field: 'OtherCharge', xlCol: xlColq, weight: 70, align: 'right' },
  { header: 'Total Amount', exportHead: 'Total Amount', field: 'NetAmount', xlCol: xlColq, weight: 70, align: 'right' },
  { header: 'Received By User', exportHead: 'Received By User', field: 'ReceivedByUser', xlCol, weight: 90 },
  { header: 'Short Received By Branch', exportHead: 'Short Received By Branch', field: 'ShortReceivedByBranch', xlCol, weight: 110 },
]

export const totalFields = ['ShortQty', 'OtherCharge', 'NetAmount']

